import { h } from 'jsx-dom';

export default h;
